module.exports = __webpack_public_path__ + "static/media/aster_new.db6c87a4.png";